export default __webpack_public_path__ + "static/media/2DShape_04.d06ad329.png";